export const getLocationDescriptor = to => {
  if (to === undefined) return undefined;
  const [pathname, search] = to.split('?');
  return {
    pathname,
    search: search ? `?${search}` : undefined
  };
};